import { Reveal } from "@/components/Reveal";
import site from "@/data/content/site.json";

const intro = site.intro;

export const Intro = () => {
  return (
    <section data-testid="intro-section" className="bg-ivory">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-16">
        <Reveal>
          <span className="text-xs tracking-[0.25em] uppercase text-terracotta font-medium">
            {intro.eyebrow}
          </span>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-4 font-serif text-2xl sm:text-3xl md:text-4xl leading-[1.3] text-brown">
            {intro.body}
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default Intro;
